/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setSchedulePublicSearchText } from 'entities/index';
import { useSearchSchedule } from 'features/searchSchedule';
import { useInvisibleCaptcha } from 'features/yaSmartCaptcha';
import { getParity, useAppDispatch, WeekParity } from 'shared/lib';

import { HeaderSearchDropdown } from '../headerSearchDropDown';
import { Navigation } from '../navigation';

import styles from './style.module.scss';
export const HeaderSchedule: FC = () => {
  const {
    groups,
    teachers,
    groupsIsLoading,
    teachersIsLoading,
    options,
    searchText,
    setOptions,
    makeOptions,
    handleChange,
    handleFocus,
    handleSelect,
    handleInputClearClick,
  } = useSearchSchedule('headerSchedule');

  const { captchaStatus } = useInvisibleCaptcha();

  const parity = getParity();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (groups?.length !== 0) {
      setOptions(makeOptions(groups));
    } else if (teachers?.length !== 0) {
      setOptions(makeOptions(teachers));
    } else {
      setOptions([]);
    }
  }, [groups, teachers]);

  const isLoading =
    teachersIsLoading ||
    groupsIsLoading ||
    (!!searchText && captchaStatus !== 'success');

  return (
    <div className={styles['header']}>
      <div className={styles['header__inner']}>
        <Link
          to={'/main'}
          className={styles['header__logo']}
          onClick={() => dispatch(setSchedulePublicSearchText(''))}
        >
          <img src={'/assets/svg/logo.svg'} alt="Логотип КапиПары" />
        </Link>

        <nav className={styles['header__nav']}>
          <Navigation />
        </nav>

        <div className={styles['header__actions']}>
          <HeaderSearchDropdown
            className={styles['page__search-dropdown']}
            placeholder="Поиск"
            onChange={handleChange}
            onFocus={() => {
              handleFocus();
              setOptions([]);
            }}
            onBlur={() => setOptions([])}
            onSelect={handleSelect}
            onClearClick={handleInputClearClick}
            isLoading={isLoading}
            options={options}
            value={searchText}
          />

          <div className={styles['week']}>
            <div className={styles['week__text']}>
              {parity === WeekParity.Even ? 'Четная неделя' : 'Нечетная неделя'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
